import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { useBackgroundDispatch } from 'src/hooks'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import {
  createPostResendPhoneVerificationCodeSuccessAction,
  createPostSendPhoneVerificationCodeFailureAction,
  createPostSendPhoneVerificationCodeInitAction,
  createPostSendPhoneVerificationCodeSuccessAction,
  resetVerificationErrors,
} from 'src/redux/actions/auth.actions'
import { BackendErrorPayload } from 'src/utils/error.utils'

type BackendErrorResponse = { response: { data: BackendErrorPayload<string> } }

type UseSendPhoneVerificationCodeVariables = {
  email: string
  resendVerification?: boolean
}

/** Send or resend a phone verification code using the legacy reducer contract. */
export const useSendPhoneVerificationCode = () => {
  const dispatch = useBackgroundDispatch()

  return useMutation({
    mutationFn: ({
      email,
      resendVerification,
    }: UseSendPhoneVerificationCodeVariables): Promise<void> => {
      dispatch(createPostSendPhoneVerificationCodeInitAction())
      return axios
        .post(
          '/users/phone/sendverification',
          { email },
          getRequestConfig(RequestConfig.Unauthed),
        )
        .then(
          (response) => {
            dispatch(resetVerificationErrors())
            if (resendVerification) {
              dispatch(
                createPostResendPhoneVerificationCodeSuccessAction(
                  response.data,
                ),
              )
            } else {
              dispatch(
                createPostSendPhoneVerificationCodeSuccessAction(response.data),
              )
            }
          },
          (err: BackendErrorResponse) => {
            dispatch(
              createPostSendPhoneVerificationCodeFailureAction(
                err.response.data,
              ),
            )
          },
        )
    },
  })
}
